// @flow
const APP_LINK_BASE = 'pfsbc://';

export const appLinks = {
  question: (id: string): string => `${APP_LINK_BASE}resources/questions/${id}`,
};
